export type ExecutionDebugMode = null | 'active' | 'cancelled';

export const StepMovingBlocker = {
  Condition: 'condition',
  Goal: 'goal',
  Branch: 'branch',
  Goto: 'goto',
  Loop: 'loop',
  ExitLoop: 'exit_loop',
  False: false,
} as const;

export type StepMovingBlockerTypes = ValueOf<typeof StepMovingBlocker>;
